var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import ListWithCatalogue from "../../../lib/comps/ListWithCatalogue/index";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { getPopupPosition } from "../../../lib/utils/styling";
import DEFAULT_COMPONENT_ICON from "../../../lib/assets/defaultComponentIcon.png";
import UcWindow from "../../../lib/UcWindow";
let CreateTriggerDialog = class CreateTriggerDialog extends Vue {
  constructor() {
    super(...arguments);
    this.shown = false;
    this.left = '0px';
    this.top = '0px';
    this.width = '380px';
    this.renderList = [];
  }
  render() {
    const h = arguments[0];
    if (!this.shown) return null; // 解脱 computed 依赖
    return h("div", [h("uc-window", {
      "attrs": {
        "left": this.left,
        "top": this.top,
        "width": this.width,
        "title": '添加触发器',
        "visible": true
      },
      "on": {
        "close": this.cancel
      }
    }, [h(ListWithCatalogue, {
      "class": "ucd-settleComponent-list",
      "attrs": {
        "data": this.renderList,
        "category-key": "category",
        "show-search": true
      },
      "scopedSlots": {
        item: this.renderItem
      }
    })])]);
  }
  renderItem(props) {
    const h = this.$createElement;
    const {
      item,
      index
    } = props;
    return h("div", {
      "key": index,
      "class": "ucd-settleComponent-item",
      "attrs": {
        "title": item.name
      },
      "on": {
        "click": () => this.handleItemClick(item)
      }
    }, [h("img", {
      "attrs": {
        "src": item.icon || DEFAULT_COMPONENT_ICON
      },
      "class": "ucd-settleComponent-itemIcon"
    }), h("div", {
      "class": "ucd-settleComponent-itemTitle"
    }, [item.name])]);
  }
  async handleItemClick(item) {
    var _pagelet$triggers, _this$respondAndClose;
    const {
      pagelet
    } = this.designer;
    const compMeta = this.uc.components[item.id];
    if (!pagelet || !compMeta) return;
    const newTriggerIndex = ((_pagelet$triggers = pagelet.triggers) === null || _pagelet$triggers === void 0 ? void 0 : _pagelet$triggers.length) || 0;
    const layout = {
      type: compMeta.id,
      componentId: this.designer.getAvailableComponentId(compMeta.id)
    };
    this.uc.completeLayout(layout);
    const newCompPath = await this.designer.spliceComp(null, `/@triggers/${newTriggerIndex}`, layout);
    (_this$respondAndClose = this.respondAndClose) === null || _this$respondAndClose === void 0 || _this$respondAndClose.call(this, {
      compPath: newCompPath,
      id: layout.componentId
    });
    this.designer.compPath = newCompPath;
  }
  cancel() {
    var _this$respondAndClose2;
    (_this$respondAndClose2 = this.respondAndClose) === null || _this$respondAndClose2 === void 0 || _this$respondAndClose2.call(this, null);
  }
  show(opt) {
    return new Promise(resolve => {
      const position = getPopupPosition({
        anchor: opt.place || document.activeElement,
        container: this.designer.$el,
        width: parseInt(this.width, 10),
        height: 400
      });
      this.renderList = Object.freeze(this.designer.uc.componentsArray.filter(x => x.type === 'trigger').map(x => ({
        id: x.id,
        name: x.name || x.id,
        icon: x.icon,
        category: x.category || '未分类'
      })));
      this.left = `${position.x}px`;
      this.top = `${position.y}px`;
      this.shown = true;
      this.respondAndClose = ans => {
        resolve(ans);
        this.shown = false;
        this.respondAndClose = undefined;
      };
    });
  }
};
CreateTriggerDialog = __decorate([Component({
  name: 'CreateTriggerDialog',
  components: {
    UcWindow
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  }
})], CreateTriggerDialog);
export default CreateTriggerDialog;
//# sourceMappingURL=CreateTriggerDialog.js.map
